import * as React from 'react';
import { connect, DispatchProp } from 'react-redux';
import { withRouter } from 'react-router';
import { IHistory } from 'src/interfaces';

import { UserModel } from '../../model/UserModel';
import { getAllUsers, updateUser } from '../../services/userService';
import { Async } from '../reusableComponents/Async';
import { BasePage } from '../reusableComponents/BasePage';
import { ErrorPage } from '../reusableComponents/ErrorPage';
import { Loader } from '../reusableComponents/Loader';
import { UserForm } from './UserForm';

export interface IUpdateUserProps extends DispatchProp<any> {
    userInstance: UserModel;
    history: IHistory;
}

export class UpdateUserImpl extends React.Component<IUpdateUserProps, {}> {
    constructor(props: IUpdateUserProps) {
        super(props);
    }

    static defaultProps: IUpdateUserProps;

    handleFormSubmit = async (values) => {
         return await updateUser(values, this.props.userInstance.props.id, this.props.history);
    }

    renderUserForm = () => {
        return <UserForm
            id="Update Form"
            userInstance={this.props.userInstance}
            onSubmit={this.handleFormSubmit}
            formModelName="forms.updateUserForm"
        />;
    }

    promise = async () => {
        await getAllUsers();
    }

    render() {
        return (
            < BasePage pageTitle="Update User" >
                <Async
                    identifier="UpdateUserForm"
                    promise={this.promise}
                    error={<ErrorPage />}
                    loader={<Loader type="async" />}
                    content={this.renderUserForm()}

                />
            </BasePage>
        );
    }
}

export function mapStateToProps(state, ownProps) {
    const userInstance = UserModel.get(ownProps.match.params.id);
    return {
        userInstance
    };
}

export const UpdateForm = withRouter(connect<{}, {}, IUpdateUserProps>(mapStateToProps)(UpdateUserImpl));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Users/UpdateForm.tsx